module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [(_vm.loading) ? _c('spinner') : _c('form', {
    attrs: {
      "data-vv-scope": "referral-confirmation"
    }
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('shortcodes-editor', {
    attrs: {
      "label": "Confirmation text",
      "name": "content",
      "validation-scope": "referral-confirmation",
      "validators": "required",
      "rows": "20",
      "shortcodes": Object.keys(_vm.shortcodes)
    },
    model: {
      value: (_vm.data.formConfirmation),
      callback: function($$v) {
        _vm.$set(_vm.data, "formConfirmation", $$v)
      },
      expression: "data.formConfirmation"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v("\n        Preview:\n        "), _c('div', {
    staticClass: "sent-message-container"
  }, [_c('div', {
    staticClass: "sent-message"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderedContent)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("Create New Referral")]), _vm._v(" "), _c('a', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
      }
    }
  }, [_vm._v("Download Submission")])])])])])], 1), _vm._v(" "), _c('button', {
    staticClass: "btn green save-btn",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.save()
      }
    }
  }, [_vm._v("Save")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c495fad","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/referral/ReferralConfirmation.vue
// module id = 1592
// module chunks = 1